import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import React, { useEffect, useState } from "react";
import labels from "../../constants/DriverDocument";
import configuration from "../../config";
import { toast } from "react-toastify";
import { each } from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Edit State
let Id = "";
function Edit({ history }) {
  const [isLoader, setIsLoader] = useState(false);

  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
  ];
  const [languages, setLanguages] = useState([]);
  const [fieldArr, setFieldArr] = useState([
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ]);
  const [errors, setErrors] = useState({
    title: "",
    description: "",
    status: "",
  });
  const [fields, setFields] = useState({});
  function handleValidation() {
    let flag = true;
    let error = {};
    each(languages, (lang, ind) => {
      if (!fields["title_" + lang.code]) {
        error["title_" + lang.code] = "Please enter title in " + lang.title;
        flag = false;
      }
    });
    if (!fields.country_id) {
      error["country_id"] = "Please select country";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    setErrors({ ...error });
    return flag;
  }
  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "driver-document/update", params: fields })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/driver-document");
            toast.success("Record updated successfully");
          } else if (data.status === 404) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };
  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }
  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "DRIVER_DOCUMENT");
      if (rightsData?.edit === false) {
        history.push("/dashboard");
      }
    });
    setIsLoader(true);
    configuration
      .getAPI({ url: "language/list", params: { status: "active" } })
      .then((data) => {
        if (data.status === 200) {
          setLanguages(data.payload);
          let languages = data.payload;
          let fieldArr_data = [];
          configuration
            .getAPI({ url: "country/list", params: { status: "active" } })
            .then((data) => {
              if (data.status === 200) {
                let catArr = [];
                each(data.payload, (singleRec) => {
                  catArr.push({
                    title: singleRec.name,
                    value: singleRec.country_id,
                    id: singleRec.country_id,
                  });
                });
                const hlpCat = {
                  id: 0,
                  title: "Country",
                  name: "country_id",
                  type: "Dropdown",
                  options: catArr,
                };
                // setFieldArr([...fieldArr, ...hlpCat])
                fieldArr_data.push(hlpCat);
                languages.map((language, index) => {
                  fieldArr_data.push({
                    id: 3 + index,
                    title: `Title [${language.title}]`,
                    name: `title_${language.code}`,
                    type: "TextInput",
                  });
                });
                setFieldArr([...fieldArr, ...fieldArr_data]);
              }
            })
            .catch((error) => {
              return toast.error(error.message);
            });
          // languages.map((language, index) => {
          //   fieldArr_data.push({
          //     id: 3 + index,
          //     title: `Title [${language.title}]`,
          //     name: `title_${language.code}`,
          //     type: "TextInput"
          //   });
          // })
          // setFieldArr([...fieldArr, ...fieldArr_data])
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });

    var url = window.location.href;
    Id = url.substring(url.lastIndexOf("/") + 1);
    configuration
      .getAPI({
        url: "driver-document/list",
        params: { driver_document_id: Id },
      })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setFields(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }, []);

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.editDriverDocument} />
      <AddEditSection
        title="Edit Driver Document"
        path="/driver-document"
        fields={fieldArr}
        fieldValue={fields}
        fieldError={errors}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Edit;
